export const abQuery = `query ($userId: String!, $featureIdentifier: String!) {
    experimentVariation(userId: $userId, featureIdentifier: $featureIdentifier) {
    variationId
    }
  }`